import { createAction, props } from '@ngrx/store';

import {
  BankDetailsCH,
  ContactDetailsCH,
  Country,
  Currency,
  LifeSituationDetailsCH,
  LifeSituationExtra,
  OddDocs,
  PersonalDetailsCH,
  RegulatoryQuestionsCH
} from '@shared/models/Account';

export const updateAccountOpeningStepSuccess = createAction('[AO CH] Update ch account opening success', props<{ step: number }>());

export const fetchCountryList = createAction('[AO CH] Fetch ch country list');
export const fetchCountryListSuccess = createAction('[AO CH] Fetch ch country list success', props<{ countries: Country[] }>());
export const fetchCurrencyListSuccess = createAction('[AO CH] Fetch ch currency list success', props<{ currencies: Currency[] }>());

export const fetchPersonalDetails = createAction('[AO CH] Fetch ch personal details');
export const fetchPersonalDetailsSuccess = createAction('[AO CH] Fetch ch personal details success', props<{ personalDetails: PersonalDetailsCH }>());

export const updatePersonalDetails = createAction('[AO CH] Update personal details', props<{ personalDetails: PersonalDetailsCH }>());
export const updatePersonalDetailsSuccess = createAction('[AO CH] Update personal details success', props<{ personalDetails: PersonalDetailsCH }>());

export const fetchContactDetails = createAction('[AO CH] Fetch ch contact details');
export const fetchContactDetailsSuccess = createAction('[AO CH] Fetch ch contact details success', props<{ contactDetails: ContactDetailsCH }>());

export const updateContactDetails = createAction('[AO CH] Update contact details', props<{ contactDetails: ContactDetailsCH }>());
export const updateContactDetailsSuccess = createAction('[AO CH] Update contact details success', props<{ contactDetails: ContactDetailsCH }>());

export const fetchBankDetails = createAction('[AO CH] Fetch ch bank details');
export const fetchBankDetailsSuccess = createAction('[AO CH] Fetch ch bank details success', props<{ bankDetails: BankDetailsCH }>());

export const updateBankDetails = createAction('[AO CH] Update bank details', props<{ bankDetails: BankDetailsCH }>());
export const updateBankDetailsSuccess = createAction('[AO CH] Update bank details success', props<{ bankDetails: BankDetailsCH }>());
export const updateBankDetailsFailed = createAction('[AO CH] Update bank details failed');

export const fetchRegulatoryQuestions = createAction('[AO CH] Fetch regulatory questions');
export const fetchRegulatoryQuestionsSuccess = createAction(
  '[AO CH] Fetch regulatory questions success',
  props<{ regulatoryQuestions: RegulatoryQuestionsCH }>()
);

export const updateRegulatoryQuestions = createAction('[AO CH] Update regulatory questions', props<{ regulatoryQuestions: RegulatoryQuestionsCH }>());
export const updateRegulatoryQuestionsSuccess = createAction(
  '[AO CH] Update regulatory questions success',
  props<{ regulatoryQuestions: RegulatoryQuestionsCH }>()
);

export const fetchLifeSituationDetails = createAction('[AO CH] Fetch ch bank details');
export const fetchLifeSituationDetailsSuccess = createAction(
  '[AO CH] Fetch ch life situation success',
  props<{ lifeSituationDetails: LifeSituationDetailsCH }>()
);

export const updateLifeSituationDetails = createAction('[AO CH] Update life situation', props<{ lifeSituationDetails: LifeSituationDetailsCH }>());
export const updateLifeSituationDetailsSuccess = createAction(
  '[AO CH] Update life situation success',
  props<{ lifeSituationDetails: LifeSituationDetailsCH }>()
);

export const showGuarantee = createAction('[AO CH] toggle show Guarantee', props<{ show: boolean }>());

export const loadOdd = createAction('[AO CH] Load odd');
export const loadOddSuccess = createAction(
  '[AO CH] Load odd success',
  props<{
    currencies: Currency[];
    countries: Country[];
    personalDetails: PersonalDetailsCH;
    contactDetails: ContactDetailsCH;
    regulatoryQuestions: RegulatoryQuestionsCH;
    lifeSituationDetails: LifeSituationDetailsCH;
  }>()
);
export const loadOddFail = createAction('[AO CH] Load odd fail', props<{ error: any }>());

export const updateOddPersonalDetails = createAction('[AO CH] Update odd personal details', props<{ personalDetails: PersonalDetailsCH }>());

export const updateOddContactDetails = createAction('[AO CH] Update odd contact details', props<{ contactDetails: ContactDetailsCH }>());

export const updateOddLifeSituationDetails = createAction(
  '[AO CH] Update odd life situation',
  props<{ lifeSituationDetails: LifeSituationDetailsCH; lifeSituationExtra: LifeSituationExtra }>()
);

export const updateOddRegulatoryQuestions = createAction(
  '[AO CH] Update odd regulatory questions',
  props<{ regulatoryQuestions: RegulatoryQuestionsCH }>()
);

export const updateOddDocs = createAction('[AO CH] Update odd docs', props<{ docs: OddDocs }>());

export const submitOdd = createAction('[AO CH] Submit odd');
export const submitOddSuccess = createAction('[AO CH] Submit odd success', props<{ firstName: string; lastName: string }>());
export const submitOddFail = createAction('[AO CH] Submit odd fail');
